module.exports = __webpack_public_path__ + "img/assembling-machine-3-shadow.1b6f78cf.png";